import { mdiArrowTopRight } from '@mdi/js';
import Icon from '@mdi/react';

export function getCurrentDate() {
    return new Date().toLocaleDateString('en-CA');
}

export function getFeedbackFormURL(email: string | null) {
    const feedbackUrl = new URL('https://tally.so/r/3xpqMJ');

    if (email) {
        feedbackUrl.searchParams.append('email', email);
    }

    return feedbackUrl.toString();
}

export function FeedbackLink({ email }: { email: string | null }) {
    return (
        <a
            href={getFeedbackFormURL(email)}
            className='inline-flex items-center gap-1 font-medium underline'
            target='_blank'
            rel='noreferrer noopener'
        >
            Give feedback <Icon path={mdiArrowTopRight} size={0.8} />
        </a>
    );
}
